export default __webpack_public_path__ + "static/media/egzoLogo.3b2b0f2e.svg";